/* eslint-disable react/self-closing-comp */
/* eslint-disable  react/prop-types */
/* eslint-disable  react/no-array-index-key */
/* eslint-disable  no-undef */
/* eslint-disable  no-useless-concat */
/* eslint-disable  no-nested-ternary */
/* eslint-disable  no-alert */
import React, { useState, useEffect, useContext } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { getJson } from 'session';
import * as action from 'modules/profile/action';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import Logo from 'assets/img/logo-colored.png';
import Divider from '@material-ui/core/Divider';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Collapse from '@material-ui/core/Collapse';
import NotificationsIcon from '@material-ui/icons/Notifications';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import SettingsIcon from '@material-ui/icons/Settings';
import { Acl } from 'modules/common/components/Acl';
// import msysLogo from 'assets/img/multisys.png';

import MiniLoader from '../../common/components/MiniLoader';
import CmsContext from '../../../context/CmsContext';

function SidebarItem({
  depthStep = 10,
  depth = 0,
  selected,
  onClickSelect,
  onCollapseClick,
  collapsed,
  setCollapsed,
  onSelected,
  setOnSelected,
  item,
  ...rest
}) {
  // const [collapsed, setCollapsed] = React.useState(false);
  const { label, items, icon, onClick: onClickProp, to, exact, name } = item;

  // function toggleCollapse() {
  // setCollapsed((prevValue) => !prevValue);
  // setCollapsed(true);
  // }

  const onClick = (nameIdx) => (e) => {
    e.preventDefault();
    if (onCollapseClick) {
      if (Array.isArray(items)) {
        setCollapsed((prevState) => !prevState);
        setOnSelected(nameIdx);

        if (nameIdx !== onSelected) {
          setCollapsed(true);
        }
      }
      if (!Array.isArray(items)) {
        setCollapsed(false);
        setOnSelected(nameIdx);
      }
    }

    if (onClickProp) {
      onClickProp(e, item);
    }
    if (onClickSelect) {
      onClickSelect(nameIdx);
    }
  };

  let expandIcon;

  if (Array.isArray(items) && items.length) {
    expandIcon =
      collapsed === true && onSelected === name ? (
        <ExpandLessIcon
          className={
            'sidebar-item-expand-arrow' + ' sidebar-item-expand-arrow-expanded'
          }
        />
      ) : (
        <ExpandMoreIcon className="sidebar-item-expand-arrow" />
      );
  }

  return (
    <>
      <ListItem
        selected={selected}
        className={`menu-item rounded p-0 ${
          selected ? 'cms-bg-color-primary cms-text-primary' : ''
        }`}
        onClick={onClick(name)}
        button
        dense
        {...rest}
      >
        {/* <div style={{ paddingLeft: depth * depthStep }} className="menu-link"> */}
        <div className="menu-link">
          {/* {Icon && <Icon className="sidebar-item-icon" fontSize="small" />} */}
          {to ? (
            <NavLink
              exact={exact}
              activeClassName={
                Array.isArray(items) && items.length
                  ? ''
                  : `active-link bg-color-primary cms-text-primary ${
                      !selected && 'active-sub-link'
                    }`
              }
              to={to}
              className="sidebar-item-text pl-5"
            >
              <span className="icon-image">
                <i className={`${icon}`} style={{ fontSize: 15 }} />
              </span>
              <span>{label}</span>
            </NavLink>
          ) : (
            <div className="sidebar-item-text">
              <span className="icon-image">
                <i className={`${icon}`} style={{ fontSize: 15 }} />
              </span>
              <span>{label}</span>
            </div>
          )}
        </div>
        {expandIcon}
      </ListItem>

      <Collapse
        in={collapsed && onSelected === name}
        timeout="auto"
        unmountOnExit
        // style={{borderRight: collapsed && onSelected === name ? `5px solid ${_.get(CMS_COLORS, "primary_color") || '#fff'}` : 'none'}}
      >
        {Array.isArray(items) ? (
          <List disablePadding dense>
            {items.map((subItem, index) => (
              <React.Fragment key={`${subItem.name}${index}`}>
                {subItem === 'divider' ? (
                  <Divider />
                ) : subItem.show ? (
                  <SidebarItem
                    depth={depth + 1}
                    depthStep={depthStep}
                    item={subItem}
                  />
                ) : (
                  ''
                )}
              </React.Fragment>
            ))}
          </List>
        ) : null}
      </Collapse>
    </>
  );
}

function MenuSidebar({ depthStep, depth, expanded, permissions, match }) {
  const [selected, setSelected] = useState('');
  const [onSelected, setOnSelected] = useState('');
  const [collapsed, setCollapsed] = React.useState(false);

  const cmsContext = useContext(CmsContext);
  const CMS_LOGO = cmsContext.findByType('LOGOS');
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const cmsLogo = _.get(CMS_LOGO, 'CORE_LOGO.cdnUrl');

  const displayLogoImage = !_.isEmpty(CMS_LOGO) ? (
    <img src={cmsLogo} alt="" className="icon-logo" />
  ) : (
    <MiniLoader />
  );

  function onClick(e, item) {
    window.alert(JSON.stringify(item, null, 2));
  }

  const onClickSelect = (name) => {
    setSelected(name);
  };

  const onCollapseClick = (value, name) => {
    setCollapsed(value);
    setOnSelected(name);
  };

  const items = [
    {
      name: 'dashboard',
      label: 'Dashboard',
      to: '/',
      exact: true,
      icon: 'fa fa-chart-line',
      description: 'Main Dashboard',
      show:
        Acl(permissions, ['VIEW MAIN DASHBOARD']) &&
        !_.get(CMS_COMPONENTS, 'DASHBOARD'),
    },
    {
      name: 'subscribers',
      label: `${
        !_.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
          ? 'Subscribers'
          : 'Registrants/ Subscribers'
      }`,
      icon: 'fa fa-users',
      to: '/subscribers',
      show:
        Acl(permissions, ['VIEW SUBSCRIBERS']) &&
        !_.get(CMS_COMPONENTS, 'SUBSCRIBERS'),
      exact: false,
    },
    'divider',
    {
      name: 'citizen',
      label: 'Citizens',
      icon: 'fa fa-user-friends',
      to: '/citizens/profiles',
      show:
        Acl(permissions, ['VIEW CITIZENS']) &&
        !_.get(CMS_COMPONENTS, 'CITIZEN'),
      exact: false,
    },
    `${!_.get(CMS_COMPONENTS, 'CITIZEN') ? 'divider' : ''}`,
    {
      name: 'gomanila_services',
      label: `${
        !_.get(CMS_COMPONENTS, 'SMART_CITY_SIDE_MENU_LABELS_V2')
          ? 'E-Government'
          : 'E-Government & E-Services'
      }`,
      icon: 'fa fa-university',
      exact: true,
      to: '/e-government',
      show:
        Acl(permissions, ['VIEW E-GOVERNMENT']) &&
        !_.get(CMS_COMPONENTS, 'GOMANILA_SERVICES'),
      items: [
        {
          name: 'eBPLS',
          label: 'eBPLS',
          to: '/ebpls',
          exact: false,
          icon: null,
          description: 'eBPLS application list',
          show:
            Acl(permissions, ['VIEW EBPLS APPLICATION']) &&
            _.get(CMS_VARIABLES, 'LGU_NAME') === 'Las Piñas',
        },
        {
          name: 'miscellaneous_fee_LP',
          label: 'Miscellaneous Fee',
          to: '/miscellaneous-fee',
          exact: false,
          icon: null,
          description: 'miscellaneous fees LP transaction list',
          show:
            Acl(permissions, ['VIEW MISCELLANEOUS FEES LP']) &&
            _.get(CMS_VARIABLES, 'LGU_NAME') === 'Las Piñas',
        },
        {
          name: 'rpt',
          label: 'RPT',
          to: '/rpt',
          exact: false,
          show:
            Acl(permissions, ['VIEW RPT']) &&
            !_.get(CMS_COMPONENTS, 'RPT_SERVICES_SUB_MENU'),
          icon: null,
        },
        {
          name: 'bpls',
          label: 'BPLS',
          to: '/bpls',
          exact: false,
          show:
            Acl(permissions, ['VIEW BPLS']) &&
            !_.get(CMS_COMPONENTS, 'BPLS_SERVICES_SUB_MENU'),
          icon: null,
        },
        {
          name: 'cedula',
          label: 'Cedula',
          to: '/cedula',
          exact: false,
          show:
            Acl(permissions, ['VIEW CEDULA']) &&
            !_.get(CMS_COMPONENTS, 'CEDULA_SERVICES_SUB_MENU'),
          icon: null,
        },
        {
          name: 'civil_registry',
          label: 'Civil Registry',
          to: '/civil-registry',
          exact: false,
          icon: null,
          description: 'Civil Registration application list',
          show:
            Acl(permissions, ['VIEW CIVIL REGISTRY']) &&
            !_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_SERVICES_SUB_MENU'),
        },
        {
          name: 'occupational_and_health',
          label: 'Occupational & Health',
          to: '/occupational-and-health',
          exact: false,
          icon: null,
          description: 'Occupational and Health application list',
          show:
            Acl(permissions, ['VIEW OCCUPATIONAL AND HEALTH']) &&
            !_.get(CMS_COMPONENTS, 'OHP_SERVICES_SUB_MENU'),
        },
        {
          name: 'health_certificate',
          label: 'Health Certificate',
          to: '/health-certificate',
          exact: false,
          icon: null,
          description: 'Health Certificate application list',
          show:
            Acl(permissions, ['VIEW HEALTH CERTIFICATE']) &&
            !_.get(CMS_COMPONENTS, 'HEALTH_CERTIFICATE_SERVICES_SUB_MENU'),
        },
        {
          name: 'occupational_permit',
          label: 'Occupational Permit',
          to: '/occupational-permit',
          exact: false,
          icon: null,
          description: 'Occupational Permit application list',
          show:
            Acl(permissions, ['VIEW OCCUPATIONAL PERMIT']) &&
            !_.get(CMS_COMPONENTS, 'OCCUPATIONAL_PERMIT_SERVICES_SUB_MENU'),
        },
        {
          name: 'police_clearance',
          label: 'Police Clearance',
          to: '/police-clearance',
          exact: false,
          icon: null,
          description: 'Police Clearance application list',
          show:
            Acl(permissions, ['VIEW POLICE CLEARANCE']) &&
            !_.get(CMS_COMPONENTS, 'POLICE_CLEARANCE_SERVICES_SUB_MENU'),
        },
        {
          name: 'real_property_tax',
          label: 'Real Property Tax',
          to: '/real-property-tax',
          exact: false,
          icon: null,
          description: 'Real Property Tax application list',
          show:
            Acl(permissions, ['VIEW REAL PROPERTY TAX']) &&
            !_.get(CMS_COMPONENTS, 'REAL_PROPERTY_TAX_SERVICES_SUB_MENU'),
        },
        {
          name: 'business_tax',
          label: 'Business Tax',
          to: '/business-tax',
          exact: false,
          icon: null,
          description: 'Business Tax application list',
          show:
            Acl(permissions, ['VIEW BTAX']) &&
            Acl(permissions, ['VIEW REAL PROPERTY TAX']) &&
            !_.get(CMS_COMPONENTS, 'BTAX_SERVICES_SUB_MENU'),
        },
        {
          name: 'OVRS',
          label: 'Ordinance Violations',
          to: '/ordinance-violation-receipts',
          exact: false,
          icon: null,
          description: 'Ordinance Violation Receipt list',
          show:
            Acl(permissions, ['VIEW OVRS']) &&
            !_.get(CMS_COMPONENTS, 'OVRS_SERVICES_SUB_MENU'),
        },
        {
          name: 'spcecial_permit',
          label: 'Special Permit',
          to: '/special-permit',
          exact: false,
          icon: null,
          description: 'Special Permit list',
          show:
            Acl(permissions, ['VIEW SPECIAL PERMIT']) &&
            !_.get(CMS_COMPONENTS, 'SPECIAL_PERMIT_SERVICES_SUB_MENU'),
        },
        {
          name: 'NOVS',
          label: 'Notice Of Violations',
          to: '/notice-of-violations',
          exact: false,
          icon: null,
          description: 'Notice Of Violations list',
          show:
            Acl(permissions, ['VIEW NOV']) &&
            !_.get(CMS_COMPONENTS, 'NOVS_SERVICES_SUB_MENU'),
        },
        {
          name: 'delivery_transactions',
          label: 'Delivery Transactions',
          to: '/delivery',
          exact: false,
          icon: null,
          description: 'Delivery transaction',
          show:
            Acl(permissions, ['VIEW DELIVERY TRANSACTIONS']) &&
            !_.get(CMS_COMPONENTS, 'DELIVERY_TRANSACTIONS_SERVICES_SUB_MENU'),
        },
        {
          name: 'social_amelioration',
          label: 'Social Amelioration',
          to: '/social-amelioration/senior-citizens',
          exact: false,
          icon: null,
          description: 'Social Amelioration',
          show:
            Acl(permissions, ['VIEW SOCIAL AMERLIORATION']) &&
            !_.get(
              CMS_COMPONENTS,
              'SOCIAL_AMELIORATION_SENIOR_CITIZENS_SERVICES_SUB_MENU'
            ),
        },
        {
          name: 'reports',
          label: 'Reports',
          to: '/reports/transactions',
          exact: false,
          icon: null,
          description: 'View Reports',
          show:
            Acl(permissions, ['VIEW REPORTS']) &&
            !_.get(CMS_COMPONENTS, 'REPORTS_SERVICES_SUB_MENU'),
        },
        {
          name: 'bpls_reports',
          label: 'BPLS Reports',
          to: '/bpls-reports/transactions',
          exact: false,
          icon: null,
          description: 'View BPLS Reports',
          show:
            Acl(permissions, ['VIEW BPLS BUSINESSES']) &&
            !_.get(CMS_COMPONENTS, 'BPLS_REPORTS_SERVICES_SUB_MENU'),
        },
        {
          name: 'gcash_reports',
          label: 'GCash Reports',
          to: '/gcash-reports/transactions',
          exact: false,
          icon: null,
          description: 'View GCash Reports',
          show:
            Acl(permissions, ['VIEW GCASH REPORTS']) &&
            !_.get(CMS_COMPONENTS, 'GCASH_REPORTS_SERVICES_SUB_MENU'),
        },
        {
          name: 'payment',
          label: 'Payments',
          to: '/payments/inquiry',
          exact: false,
          icon: null,
          description: 'View payment transactions',
          show:
            Acl(permissions, ['VIEW PAYMENT MENU']) &&
            !_.get(CMS_COMPONENTS, 'PAYMENT_REPORTS_SERVICES_SUB_MENU'),
        },
        {
          name: 'social_ameliorations',
          label: 'Social Ameliorations',
          to: '/social-ameliorations',
          exact: false,
          icon: null,
          description: 'View Social Ameliorations',
          show:
            Acl(permissions, ['VIEW SOCIAL AMELIORATION']) &&
            !_.get(
              CMS_COMPONENTS,
              'SOCIAL_AMELIORATIONS_REPORTS_SERVICES_SUB_MENU'
            ),
        },
        {
          name: 'billings',
          label: 'Billings',
          to: '/billing',
          exact: false,
          icon: null,
          description: 'View billings',
          show:
            Acl(permissions, ['VIEW BILLINGS']) &&
            !_.get(CMS_COMPONENTS, 'BILLINGS_REPORTS_SERVICES_SUB_MENU'),
        },
        {
          name: 'miscellaneous_fees',
          label: 'Miscellaneous Fee',
          to: '/miscellaneous-fees',
          exact: false,
          icon: null,
          description: 'View miscellaneous fees',
          show: Acl(permissions, ['VIEW MISCELLANEOUS FEES']),
        },
        {
          name: 'qr_code_scanner',
          label: 'QR Scanner',
          to: '/scanner',
          exact: false,
          icon: null,
          description: 'QR Code Scanner',
          show:
            Acl(permissions, ['QR CODE SCANNER']) &&
            !_.get(CMS_COMPONENTS, 'QR_CODE_REPORTS_SERVICES_SUB_MENU'),
        },
      ],
    },
    {
      name: 'e-commerce',
      label: 'E-Commerce',
      to: '/e-commerce',
      exact: false,
      icon: 'fa fa-shopping-cart',
      description: 'E-commerce',
      show:
        Acl(permissions, ['VIEW E-COMMERCE']) &&
        !_.get(CMS_COMPONENTS, 'E_COMMERCE'),
    },
    {
      name: 'e-bills',
      label: 'E-Bills Payment',
      to: '/e-bills',
      exact: false,
      icon: 'fas fa-receipt',
      description: 'E-bills',
      show:
        Acl(permissions, ['VIEW E-BILLS']) &&
        !_.get(CMS_COMPONENTS, 'E_BILLS_PAYMENT'),
    },
    {
      name: 'e-service',
      label: 'E-Services',
      to: '/e-services',
      exact: false,
      icon: 'far fa-handshake',
      description: 'E-bills',
      show:
        Acl(permissions, ['VIEW E-SERVICES']) &&
        !_.get(CMS_COMPONENTS, 'E_SERVICES'),
    },
    {
      name: 'news',
      label: 'E-News',
      to: '/news',
      exact: false,
      icon: 'fas fa-newspaper',
      description: 'News Menu',
      show: Acl(permissions, ['VIEW NEWS']) && !_.get(CMS_COMPONENTS, 'E_NEWS'),
      items: [
        {
          name: 'articles',
          label: 'Articles',
          to: '/news/articles',
          exact: false,
          icon: null,
          description: 'articles settings',
          show: true && !_.get(CMS_COMPONENTS, 'ARTICLES_NEWS_SUB_MENU'),
        },
      ],
    },
    {
      name: 'e_wallet',
      label: 'E-Wallet Services',
      to: '/e-wallet',
      exact: false,
      icon: 'fas fa-wallet',
      description: 'E-Wallet Menu',
      show:
        Acl(permissions, ['VIEW E-WALLET']) &&
        !_.get(CMS_COMPONENTS, 'E_WALLET_SERVICES'),
      items: [
        {
          name: 'E-Bills',
          label: 'Bills',
          to: '/bills',
          exact: false,
          icon: null,
          description: 'E-Bills List',
          show:
            Acl(permissions, ['E-WALLET BILLS']) &&
            !_.get(CMS_COMPONENTS, 'E_BILLS_E_WALLET_SERVICES_SUB_MENU'),
        },
        {
          name: 'Cash In',
          label: 'Cash-In',
          to: '/cash-in',
          exact: false,
          icon: null,
          description: 'Cash-In List',
          show:
            Acl(permissions, ['E-WALLET CASH IN']) &&
            !_.get(CMS_COMPONENTS, 'CASH_IN_E_WALLET_SERVICES_SUB_MENU'),
        },
        {
          name: 'Cash Transfer',
          label: 'Cash Transfer',
          to: '/cash-transfer',
          exact: false,
          icon: null,
          description: 'Cash Transfer List',
          show:
            Acl(permissions, ['E-WALLET CASH TRANSFER']) &&
            !_.get(CMS_COMPONENTS, 'CASH_TRANSFER_E_WALLET_SERVICES_SUB_MENU'),
        },
        {
          name: 'Receive Fund',
          label: 'Receive Fund',
          to: '/receive-fund',
          exact: false,
          icon: null,
          description: 'Receive Fund List',
          show:
            Acl(permissions, ['E-WALLET RECEIVE FUND']) &&
            !_.get(CMS_COMPONENTS, 'RECEIVED_FUND_E_WALLET_SERVICES_SUB_MENU'),
        },
        // {
        //   name: 'Transfer Fund'
        //   label: 'Transfer Fund',
        //   to: '/e-wallet/transfer-fund',
        //   exact: false,
        //   icon: null,
        //   description: 'Transfer Fund List',
        //   show: true,
        // },
        {
          name: 'Mobile Load',
          label: 'Mobile Load',
          to: '/mobile-load',
          exact: false,
          icon: null,
          description: 'Mobile Load List',
          show:
            Acl(permissions, ['E-WALLET MOBILE LOAD']) &&
            !_.get(CMS_COMPONENTS, 'MOBILE_LOAD_E_WALLET_SERVICES_SUB_MENU'),
        },
        {
          name: 'Wallet Support',
          label: 'Wallet Support',
          to: '/wallet-support',
          exact: false,
          icon: null,
          description: 'Wallet Support',
          show:
            Acl(permissions, ['E-WALLET WALLET SUPPORT']) &&
            !_.get(
              CMS_COMPONENTS,
              'E_WALLET_SUPPORT_E_WALLET_SERVICES_SUB_MENU'
            ),
        },
      ],
    },
    {
      name: 'e-help',
      label: 'E-Help',
      icon: 'fa fa-university',
      exact: true,
      to: '/e-help',
      show:
        Acl(permissions, ['VIEW E-HELP']) && !_.get(CMS_COMPONENTS, 'E_HELP'),
    },
    'divider',
    {
      name: 'gen_settings',
      label: 'General Settings',
      to: '/general-settings',
      exact: false,
      icon: 'fa fa-cog',
      description: 'General Settings',
      show: Acl(permissions, ['VIEW GENERAL SETTINGS']),
      items: [
        {
          name: 'address_settings',
          label: 'Address',
          to: '/general-settings/address',
          exact: false,
          icon: null,
          description: 'Address settings',
          show: Acl(permissions, ['VIEW ADDRESS GENERAL SETTINGS']),
        },
        {
          name: 'appointment_mangement',
          label: 'Appointment',
          to: '/general-settings/appointment-management',
          exact: false,
          icon: null,
          description: 'Appointment Management',
          show: Acl(permissions, ['VIEW APPOINTMENT GENERAL SETTINGS']),
        },
        {
          name: 'billing_imports',
          label: 'Billing Imports',
          to: '/general-settings/billing-imports',
          exact: false,
          icon: null,
          description: 'Billing Imports',
          show: Acl(permissions, ['VIEW BILLING IMPORT GENERAL SETTINGS']),
        },
        {
          name: 'chairman',
          label: 'Brgy. Chairmen',
          to: '/general-settings/brgy-chairmen',
          exact: false,
          icon: null,
          description: 'Brgy Chairman Settings',
          show: Acl(permissions, ['VIEW BRGY CHAIRMEN GENERAL SETTINGS']),
        },
        {
          name: 'cms',
          label: 'CMS',
          to: '/general-settings/cms',
          exact: false,
          icon: null,
          description: 'CMS',
          show: Acl(permissions, ['VIEW CMS GENERAL SETTINGS']),
        },
        {
          name: 'business_establishments',
          label: 'Business Ests.',
          to: '/general-settings/business-establishments',
          exact: false,
          icon: null,
          description: 'Business Establishment listing settings',
          show: Acl(permissions, [
            'VIEW BUSINESS ESTABLISHMENT GENERAL SETTINGS',
          ]),
        },
        {
          name: 'calendar-entries',
          label: 'Calendar Entries',
          to: '/general-settings/calendar-entries',
          exact: false,
          icon: null,
          description: 'calendar-entries settings',
          show: Acl(permissions, ['VIEW CALENDAR ENTRIES GENERAL SETTINGS']),
        },
        {
          name: 'citizenship_settings',
          label: 'Citizenship',
          to: '/general-settings/citizenship',
          exact: false,
          icon: null,
          description: 'Citizenship settings',
          show: Acl(permissions, ['VIEW CITIZENSHIP GENERAL SETTINGS']),
        },

        {
          name: 'e_wallet_services',
          label: 'E-Wallet Services',
          to: '/e-wallet-services',
          exact: false,
          icon: null,
          description: 'E Wallet Services',
          show: Acl(permissions, ['VIEW EWALLET SERVICES GENERAL SETTINGS']),
        },
        {
          name: 'faq',
          label: 'Frequently Asked Questions',
          to: '/general-settings/faq',
          exact: false,
          icon: null,
          description: 'Frequently Asked Questions',
          show: Acl(permissions, ['VIEW FAQ GENERAL SETTINGS']),
        },
        {
          name: 'hospitals',
          label: 'Hospitals',
          to: '/general-settings/hospitals',
          exact: false,
          icon: null,
          description: 'Hospital CRUD',
          show: Acl(permissions, ['VIEW HOSPITAL GENERAL SETTINGS']),
        },
        {
          name: 'how_to',
          label: 'How To',
          to: '/general-settings/how-to',
          exact: false,
          icon: null,
          description: 'How To',
          show: Acl(permissions, ['VIEW HOW TO GENERAL SETTINGS']),
        },
        {
          name: 'institution_settings',
          label: 'Institution',
          to: '/general-settings/institution',
          exact: false,
          icon: null,
          description: 'institution settings',
          show: Acl(permissions, ['VIEW INSTITUTION GENERAL SETTINGS']),
        },
        {
          name: 'profession_settings',
          label: 'Profession',
          to: '/general-settings/profession',
          exact: false,
          icon: null,
          description: 'Profession settings',
          show: Acl(permissions, ['VIEW PROFESSION GENERAL SETTINGS']),
        },
        // {
        //   name: 'ovrs_settings',
        //   label: 'OVRS Settings',
        //   to: '/general-settings/ovrs',
        //   exact: false,
        //   icon: null,
        //   description: 'Traffic Violation Fees Matrix settings',
        //   show: Acl(permissions, ['VIEW PROFESSION GENERAL SETTINGS']),
        // },
        {
          name: 'requirements',
          label: 'Requirements',
          to: '/general-settings/requirements',
          exact: false,
          icon: null,
          description: 'requirements settings',
          show: Acl(permissions, ['VIEW REQUIREMENT GENERAL SETTINGS']),
        },
        {
          name: 'smart_city_services',
          label: 'Smart City Services',
          to: '/smart-city-services',
          exact: false,
          icon: null,
          description: 'Smart City Services',
          show: Acl(permissions, ['VIEW SMART CITY SERVICES GENERAL SETTINGS']),
        },
        {
          name: 'system_modules',
          label: 'System Modules',
          to: '/general-settings/system-modules',
          exact: false,
          icon: null,
          description: 'System Modules',
          show: Acl(permissions, ['VIEW SYSTEM MODULE GENERAL SETTINGS']),
        },
        {
          name: 'otp_modules',
          label: 'OTP Modules',
          to: '/general-settings/otp-modules',
          exact: false,
          icon: null,
          description: 'OTP Modules',
          show: Acl(permissions, ['VIEW OTP GENERAL SETTINGS']), // replace with otp module later
        },
        {
          name: 'mini_program_government',
          label: 'Mini Program Government',
          to: '/general-settings/mini-program-government',
          exact: false,
          icon: null,
          description: 'System Modules',
          show: Acl(permissions, ['VIEW MINI PROGRAM GOVERNMENT']),
        },
        {
          name: 'csv_upload',
          label: 'CSV Upload',
          to: '/general-settings/csv-upload',
          exact: false,
          icon: null,
          description: 'System Modules',
          show: Acl(permissions, ['VIEW MINI PROGRAM GOVERNMENT']), // update with VIEW CSV UPLOAD later
        },
      ],
    },
    {
      name: 'access_control',
      label: 'Access Control',
      to: '/role-management',
      exact: false,
      icon: 'fa fa-key',
      description: 'Access Control',
      show: Acl(permissions, ['VIEW ACCESS CONTROL']),
      items: [
        {
          name: 'role_management',
          label: 'Role Management',
          to: '/role-management',
          exact: false,
          icon: null,
          description: 'Role Management',
          show: Acl(permissions, ['VIEW ROLE MANAGEMENT']),
        },
        {
          name: 'permissions',
          label: 'Permissions',
          to: '/permission-management',
          exact: false,
          icon: null,
          description: 'Permission Management',
          show: Acl(permissions, ['VIEW PERMISSION']),
        },
        {
          name: 'user_management',
          label: 'User Management',
          to: '/user-management',
          exact: false,
          icon: null,
          description: 'User Management',
          show: Acl(permissions, ['VIEW USER MANAGEMENT']),
        },
      ],
    },
    'divider',
    {
      name: 'important_notification',
      label: 'City Announcements',
      to: '/important-notification',
      exact: false,
      icon: 'fa fa-bullhorn',
      description: 'Important Notification',
      show: Acl(permissions, ['VIEW IMPORTANT NOTIFICATION']),
    },
    {
      name: 'notifications',
      label: 'Notifications',
      to: '/notifications',
      exact: false,
      icon: 'far fa-paper-plane',
      description: 'Notifications',
      show: Acl(permissions, ['VIEW EMAIL SMS NOTIFICATION']),
    },
    // {
    //   name: 'chat_support',
    //   label: 'Chat Support',
    //   to: '/general-settings/chat-support',
    //   exact: false,
    //   icon: 'fa fa-comment-dots',
    //   description: 'Chat Support',
    //   show: Acl(permissions, ['CHAT SUPPORT']),
    // },
    {
      to: '/',
      name: 'settings',
      label: 'Settings',
      Icon: SettingsIcon,
      items: [
        { name: 'profile', label: 'Profile', to: '/' },
        { name: 'insurance', label: 'Insurance', onClick, to: '/' },
        'divider',
        {
          to: '/',
          name: 'notifications',
          label: 'Notifications',
          Icon: NotificationsIcon,
          items: [
            { to: '/', name: 'email', label: 'Email', onClick },
            {
              to: '/',
              name: 'desktop',
              label: 'Desktop',
              Icon: DesktopWindowsIcon,
              items: [
                { to: '/', name: 'schedule', label: 'Schedule' },
                { to: '/', name: 'frequency', label: 'Frequency' },
              ],
            },
            { to: '/', name: 'sms', label: 'SMS' },
          ],
        },
      ],
    },
  ];

  useEffect(() => {
    if (selected === '') {
      const target = items.filter((item) => _.get(item, 'to') === match.url);
      setSelected(_.get(target, '0.name'));
    }
  }, []);

  const demoData = JSON.parse(sessionStorage.getItem('demoData'));
  return (
    <aside className="main-sidebar">
      <div className="admin-logged">
        <div className="">
          <span className="navbar-brand pt-5 mx-0">
            {!_.isEmpty(demoData) ? (
              <img
                src={demoData.image_url}
                alt=""
                style={{
                  width: 'auto',
                  height: `${demoData.height}px`,
                  fill: '#ffffff',
                }}
              />
            ) : (
              displayLogoImage
            )}
          </span>
        </div>
      </div>
      <div className="sidebar">
        <List disablePadding dense className="menu-list">
          {items.map((sidebarItem, index) => (
            <React.Fragment key={`${sidebarItem.name}${index}`}>
              {sidebarItem === 'divider' ? (
                <Divider />
              ) : sidebarItem.show ? (
                <SidebarItem
                  depthStep={depthStep}
                  depth={depth}
                  expanded={expanded}
                  item={sidebarItem}
                  onClickSelect={onClickSelect}
                  selected={sidebarItem.name === selected}
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  onCollapseClick={onCollapseClick}
                  onSelected={onSelected}
                  setOnSelected={setOnSelected}
                />
              ) : (
                ''
              )}
            </React.Fragment>
          ))}
        </List>
      </div>
      <div className="msys-icon">
        <div className="msys-icon-cont f-row">
          <div className="pby"> Powered by: </div>
          <div>
            <img
              className="msys-icon-img-sm"
              alt=""
              src={_.get(CMS_LOGO, 'FOOTER_LOGO.cdnUrl')}
            />
          </div>
        </div>
      </div>
    </aside>
  );
}

const mapStateToProps = ({ match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: getJson('profile'),
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(MenuSidebar);
